export const handleAlertMessage = () => {
  alert('Diese Funktion steht noch nicht zur Verfügung.');
};
